import React from 'react';
import './Parents.css';
import { useLanguage } from '../context/LanguageContext';

function Parents() {
  const { t } = useLanguage();
  return (
    <div className='parents-container'>
      <h2>{t.parents_title}</h2>

      <div className='parents-columns'>
        <div className='parents-column'>
          <h3>{t.parents_gf}</h3>
          <p>Claudia Legorreta Mosqueda</p>
          <p>Eduardo Valdés Rangel</p>
        </div>

        <div className='parents-column'>
          <h3>{t.parents_bf}</h3>
          <p>Gloria Marcela Aranzábal Pastrana</p>
          <p>Paul Albert Charles Boyer Fernández</p>
        </div>
      </div>
    </div>
  );
}

export default Parents;